<template>
	<div
		class="block w-full cursor-pointer px-2 py-1.5 text-won-blue no-underline"
	>
		<div class="flex w-full items-center gap-1">
			<div
				:class="usage != 0 || isSubscribe ? 'bg-won-green' : 'bg-won-red'"
				class="flex h-6 w-full max-w-6! items-center justify-center rounded-full text-white"
			>
				<span
					v-if="isUnlimitedForPremium && isSubscribe"
					class="text-[12px]"
				>
					∞
				</span>
				<span
					v-else
					class="text-[10px] font-medium"
				>
					{{ usage }}
				</span>
			</div>
					
			<div class="flex w-full items-center justify-between gap-2">
				<p class="won-color-nav-gray rounded px-0.5 py-1 text-[12px] leading-tight text-won-blue">
					{{ description }} left
				</p>

				<div v-if="isSingleFeature">
					<ChevronRight />
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import ChevronRight from '../../../../icons/chevron-right.vue';

defineProps({
	usage: {
		type: Number,
		default: 0,
	},
	description: {
		type: String,
		default: '',
	},
	isSingleFeature: {
		type: Boolean,
		default: false
	},
	isSubscribe: {
		type: Boolean,
		default: false
	},
	isUnlimitedForPremium: {
		type: Boolean,
		default: false
	}
});
</script>
